import React from "react";
import NoContentSvg from "../../asset/icon/NoContent.svg";

export default function Empty({
    text,
    footer,
    style,
}) {
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                flex: 1,
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
                ...style,
            }}
        >
            <NoContentSvg style={{flex: "none", fontSize: 132}} />
            <div
                style={{
                    flex: "none",
                    marginTop: 12,
                    color: "#90A4AD",
                }}
            >
                {text}
            </div>
            {footer}
        </div>
    );
}
